export const FeatureFlags = {
  WokflowAgents: {
    ReelDirector: ["*"],
    CreativeDirector: ["*"],
    ReportingOptimization: ["*"],
    VideoDirector: ["*"],
    CompetitorResearch: [
      "3b5e1554-76c4-49fc-af5d-548e04ca5932",
      "17abb466-4a41-4600-a8cd-62780bebfff7",
      "0f0f4ba7-6695-4c71-8ffb-bc5b3f6778f9",
      "cb056541-6000-4f54-ab3b-abfdce1b4723",
      "da162415-a7cf-446c-ae7f-c59ca9893ab7",
      "8c972840-2bd9-4bb4-b848-95c5629ec849",
    ],
    TargetAudience: [
      "3b5e1554-76c4-49fc-af5d-548e04ca5932",
      "17abb466-4a41-4600-a8cd-62780bebfff7",
      "0f0f4ba7-6695-4c71-8ffb-bc5b3f6778f9",
      "cb056541-6000-4f54-ab3b-abfdce1b4723",
      "da162415-a7cf-446c-ae7f-c59ca9893ab7",
      "8c972840-2bd9-4bb4-b848-95c5629ec849",
    ],
    SocialManager: [
      "3b5e1554-76c4-49fc-af5d-548e04ca5932",
      "17abb466-4a41-4600-a8cd-62780bebfff7",
      "0f0f4ba7-6695-4c71-8ffb-bc5b3f6778f9",
      "cb056541-6000-4f54-ab3b-abfdce1b4723",
      "da162415-a7cf-446c-ae7f-c59ca9893ab7",
      "8c972840-2bd9-4bb4-b848-95c5629ec849",
    ],
  },
  PaidMedia: {
    /**
     * Gates the new Paid Media Overview page (KPI snapshot + top-movers +
     * attention + external signals). When this resolves to `true` for the
     * current org, render `PaidMediaOverviewV2Page`; otherwise keep the
     * existing v1 overview. `["*"]` = everyone, `[]` = nobody, or list
     * specific organization UUIDs to canary.
     */
    OverviewV2: ["*"] as string[],
  },
};

/** Returns `true` when the allowlist contains `*` or the given orgId. */
export function isFeatureEnabled(allowlist: readonly string[], orgId: string | undefined | null): boolean {
  if (!allowlist.length) return false;
  if (allowlist.includes("*")) return true;
  return !!orgId && allowlist.includes(orgId);
}
